import React from 'react'

import { Alert } from 'antd'
import { useSelector } from 'react-redux'

import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { getFileTooLargeDescription } from '../../../utils/files'

const FileTooLargeMessage = ({ file }) => {
  const t = useSelector(selectTranslate)

  if (!file) {
    return null
  }

  return (
    <Alert
      type='error'
      message={t('file_too_large_message.title')}
      description={getFileTooLargeDescription(file, t)}
      style={{ width: '100%', marginTop: '10px' }}
      showIcon
    />
  )
}

export default FileTooLargeMessage
